import React from 'react';
import classNames from 'classnames';
import { TennistalkerIcon } from './SocialIcons';

const Logo: React.FC = () => {
  const className = classNames(
    'flex',
    'items-center',
    'gap-3',
    'border',
    'border-solid',
    'border-accent-accent-6',
    'hover:border-accent-accent-8',
    'hover:bg-accent-accent-3',
    'hover:rounded-xl',
    'cursor-pointer',
  );
  return (
    <div className={className}>
      <TennistalkerIcon />
      <div className='hidden font-[Helvetica] text-2xl leading-normal font-bold tracking-[-0.72px] not-italic md:block'>
        TennisTalker
      </div>
    </div>
  );
};

export default Logo;
